"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export function AppPostMessage() {
  const router = useRouter();

  const refreshMessage = (message: any) => {
    if (!message.data || !message.data.action) return;

    if (message.data.action === "refreshMessage") {
      router.refresh();
    }
  };

  useEffect(() => {
    window.addEventListener("message", refreshMessage);

    return () => {
      window.removeEventListener("message", refreshMessage);
    };
  }, []);

  return null;
}
